import styled from "styled-components";

export const StyledContainer = styled.div`
  padding: 20px 0;
`;
export const StyledHeader = styled.div`
  margin-bottom: 10px;

  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;

  & > *:first-child {
    grid-column: span 2;
  }

  @media (min-width: 768px) {
    margin-bottom: 30px;
    grid-template-columns: repeat(9, 1fr);
    gap: 10px;
    & > *:first-child {
      grid-column: span 3;
    }

    & > div:not(:first-child) {
      justify-self: center;
      grid-column: span 2;
    }
  }
`;
export const HeaderRow = styled.div`
  color: #1d3178;
  font-size: clamp(0.75rem, 0.4773rem + 1.3636vw, 1.5rem);
  font-weight: 700;
  line-height: 1;
`;
